import { storeToRefs } from "pinia";
import { useUser } from "../composition-functions/user";

export function shouldShowSensitiveMandantData(): boolean {
  const userStore = useUser();
  const { canAccessSensitiveMandantData } = storeToRefs(userStore);
  return canAccessSensitiveMandantData.value === true;
}
